<template>
  <div
    class="max-w-min rounded-full p-0.5"
    :class="bgColor"
  >
    <CheckSmall :custom-style="customStyle" />
  </div>
</template>

<script>
export default {
  name: 'CheckRoundedSmall',

  props: {
    bgColor: {
      type: String,
      default: 'bg-green-600',
    },
    customStyle: {
      type: String,
      default: 'h-2.5 w-2.5 text-white',
    },
  },
}
</script>
